export default __webpack_public_path__ + "static/ISO-45001-BV-Logo-646796b0afad5d55a60aa79dd9d44352.png";